(function () {
  'use strict';
  if (window.NektarWishlist || !window.NektarWishlistStore) return;
  const api = window.NektarWishlistStore;
  let storage;
  try { storage = localStorage; } catch { /* private/blocked browser storage */ }
  const store = api.create(api.localAdapter(storage));
  const root = window.Shopify?.routes?.root || '/';
  const pending = new Map(), cache = new Map();
  let config = {}; try { config = JSON.parse(document.getElementById('NektarGrowthConfig')?.textContent || '{}'); } catch { /* defaults */ }
  const money = value => new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', { style: 'currency', currency: config.currency || 'EUR' }).format(value / 100);
  const element = (tag, text, className) => { const el = document.createElement(tag); if (text) el.textContent = text; if (className) el.className = className; return el; };
  function announce(text) { const el = document.getElementById('NektarGrowthStatus'); if (el) el.textContent = text; }
  function placement(button) {
    if (button.closest('nektar-wishlist')) return 'wishlist_page';
    const container = button.closest('[data-nektar-placement]')?.dataset.nektarPlacement;
    return ({ 'related-products': 'related_products', 'complementary-products': 'complementary_products', 'cart-cross-sell': 'cross_sell', 'product-page': 'product_page', 'product-card': 'collection_card' })[container || button.dataset.placement] || button.dataset.placement || 'collection_card';
  }
  function reference(button) {
    const info = placement(button) === 'product_page' ? button.closest('product-info') : null;
    return { productHandle: button.dataset.handle, productId: button.dataset.productId,
      variantId: info ? info.querySelector('product-form [name="id"]')?.value : button.dataset.variantId };
  }
  function sync() {
    const count = store.snapshot().length;
    document.querySelectorAll('[data-nektar-wishlist-count]').forEach(el => { if (el.textContent !== String(count)) el.textContent = String(count); });
    document.querySelectorAll('[data-nektar-wishlist-open]').forEach(el => {
      el.setAttribute('aria-label', `Je favorieten (${count})`);
      const icon = el.querySelector('[data-nektar-wishlist-icon]'); if (icon && icon.textContent !== (count ? '♥' : '♡')) icon.textContent = count ? '♥' : '♡';
    });
    document.querySelectorAll('[data-nektar-wishlist-toggle]').forEach(button => {
      const saved = store.has(button.dataset.handle);
      button.setAttribute('aria-pressed', String(saved)); button.classList.toggle('is-saved', saved);
      button.setAttribute('aria-label', (saved ? 'Verwijder uit favorieten: ' : 'Bewaar als favoriet: ') + (button.dataset.title || 'artikel'));
    });
    document.querySelectorAll('[data-wishlist-storage-note]').forEach(el => { el.hidden = store.persistent(); });
  }
  const snapshot = () => store.snapshot();
  window.NektarWishlist = Object.freeze({ snapshot, contains: handle => store.has(handle), storageKey: api.key });
  store.subscribe(() => { sync(); document.dispatchEvent(new Event('nektar:wishlist-changed')); });
  window.addEventListener('storage', e => { if (e.key === api.key || e.key === null) store.sync(); });
  window.addEventListener('pageshow', () => { store.sync(); sync(); });
  let queued = false;
  new MutationObserver(records => {
    if (!queued && records.some(r => [...r.addedNodes].some(n => n.nodeType === 1))) {
      queued = true; queueMicrotask(() => { queued = false; sync(); });
    }
  }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('click', e => {
    const button = e.target.closest('[data-nektar-wishlist-toggle]');
    if (button) {
      e.preventDefault();
      if (placement(button) === 'product_page' && !store.has(button.dataset.handle) && button.closest('product-info')?.pendingRequestUrl) {
        announce('Je maat wordt geladen. Bewaar het artikel zodra je keuze zichtbaar is.'); return;
      }
      const result = store.toggle(reference(button));
      if (result.status === 'full') { announce('Je kunt maximaal 100 favorieten bewaren.'); return; }
      if (!['added', 'removed'].includes(result.status)) return;
      const name = result.status === 'added' ? 'wishlist_add' : 'wishlist_remove';
      const detail = { ...result.item, sourcePlacement: placement(button), timestamp: new Date().toISOString() };
      document.dispatchEvent(new CustomEvent(name, { detail }));
      window.NektarEvents?.emit(name, detail);
      announce((result.status === 'added' ? 'Bewaard bij je favorieten.' : 'Verwijderd uit je favorieten.') + (store.persistent() ? '' : ' Bewaren werkt nu alleen zolang dit venster open blijft.'));
    }
    if (e.target.closest('[data-nektar-wishlist-open]')) {
      const dialog = document.getElementById('NektarWishlistDialog');
      if (dialog && !dialog.open) { dialog.showModal(); dialog.querySelector('nektar-wishlist')?.render(); }
    }
    if (e.target.closest('[data-nektar-dialog-close]')) document.getElementById('NektarWishlistDialog')?.close();
  });
  async function product(handle, fresh = false) {
    if (!fresh && cache.has(handle) && Date.now() - cache.get(handle).at < 60000) return cache.get(handle).value;
    if (pending.has(handle)) return pending.get(handle);
    const task = (async () => {
      const controller = new AbortController(), timer = setTimeout(() => controller.abort(), 10000);
      try {
        // Request the Liquid view: Shopify's JSON content negotiation bypasses alternate templates.
        const response = await fetch(root + 'products/' + encodeURIComponent(handle) + '?view=nektar-wishlist', { headers: { Accept: 'text/html' }, cache: 'no-store', signal: controller.signal });
        if (response.status === 404 || response.status === 410) return null;
        if (!response.ok) throw new Error('unavailable');
        const value = await response.json(), p = value.product;
        if (!p || String(p.handle) !== handle || !p.id || typeof p.title !== 'string' || typeof p.available !== 'boolean' || !Array.isArray(p.variants) ||
          !p.variants.every(v => v.id && typeof v.available === 'boolean' && Number.isFinite(v.price)) || !Array.isArray(value.quickAddVariantIds)) throw new Error('unavailable');
        if (cache.size >= api.limit) cache.delete(cache.keys().next().value);
        cache.set(handle, { at: Date.now(), value }); return value;
      } finally { clearTimeout(timer); pending.delete(handle); }
    })();
    pending.set(handle, task); return task;
  }
  function selection(data, ref) {
    const p = data.product;
    const selected = ref.variantId ? p.variants.find(v => String(v.id) === ref.variantId) : null;
    const variant = selected || p.variants.find(v => v.available) || p.variants[0];
    return { variant, missingSelection: !!ref.variantId && !selected, safe: p.available === true && variant?.available === true &&
      (!ref.productId || String(p.id) === ref.productId) && (ref.variantId ? !!selected : p.variants.length === 1) &&
      Array.isArray(data.quickAddVariantIds) && data.quickAddVariantIds.includes(String(variant.id)) };
  }
  class Wishlist extends HTMLElement {
    connectedCallback() { if (this.onChange) return; this.onChange = () => this.render(); document.addEventListener('nektar:wishlist-changed', this.onChange); this.render(); }
    disconnectedCallback() { document.removeEventListener('nektar:wishlist-changed', this.onChange); this.onChange = null; this.generation = (this.generation || 0) + 1; }
    async render() {
      if (this.closest('dialog') && !this.closest('dialog').open) return;
      const focusWasInside = this.contains(document.activeElement), generation = this.generation = (this.generation || 0) + 1;
      this.replaceChildren(); const refs = snapshot();
      if (!refs.length) {
        const empty = element('p', 'Je hebt nog geen favorieten. Bewaar een artikel met het hartje.'); empty.tabIndex = -1;
        this.append(empty); this.removeAttribute('aria-busy'); if (focusWasInside) empty.focus(); return;
      }
      this.setAttribute('aria-busy', 'true');
      for (const ref of refs.slice(0, this.limit || 12)) {
        let data;
        try { data = await product(ref.productHandle); } catch { data = undefined; }
        if (this.generation !== generation || !this.isConnected) return;
        if (data === null || (data && ref.productId && String(data.product.id) !== ref.productId)) {
          cache.delete(ref.productHandle); store.remove(ref.productHandle); announce('Een niet meer beschikbaar artikel is uit je favorieten verwijderd.'); return;
        }
        this.append(this.card(ref, data));
      }
      if (refs.length > (this.limit || 12)) {
        const more = element('button', 'Meer favorieten tonen', 'button button--secondary'); more.type = 'button';
        more.addEventListener('click', () => { this.limit = (this.limit || 12) + 12; this.render(); }); this.append(more);
      }
      this.removeAttribute('aria-busy'); sync();
      if (focusWasInside) this.querySelector('button, a')?.focus();
    }
    card(ref, data) {
      const p = data?.product, article = element('article', null, 'nektar-wishlist-card'); article.dataset.handle = ref.productHandle;
      const { variant, safe, missingSelection } = data ? selection(data, ref) : {};
      const url = root + 'products/' + encodeURIComponent(ref.productHandle) + (ref.variantId ? '?variant=' + ref.variantId : '');
      if (p?.featured_image) try {
        const src = new URL(p.featured_image, location.origin);
        if (src.protocol === 'https:' || src.origin === location.origin) {
          const img = element('img'); img.src = src.href; img.alt = p.title; img.width = 320; img.height = 400; img.loading = 'lazy'; article.append(img);
        }
      } catch { /* malformed public image reference */ }
      const heading = element('h2', null, 'h3'), link = element('a', p?.title || 'Artikel tijdelijk niet beschikbaar'); link.href = url; heading.append(link); article.append(heading);
      if (variant && Number.isFinite(variant.price)) {
        const price = element('p', money(variant.price), 'nektar-wishlist-price');
        if (Number.isFinite(variant.compare_at_price) && variant.compare_at_price > variant.price) {
          const old = element('s', money(variant.compare_at_price)); old.setAttribute('aria-label', 'Oorspronkelijke prijs: ' + money(variant.compare_at_price)); price.append(' ', old);
        }
        article.append(price);
      }
      if (missingSelection) article.append(element('p', 'Je bewaarde variant is niet meer beschikbaar. Kies opnieuw op de productpagina.'));
      else if (variant?.title && variant.title !== 'Default Title') article.append(element('p', (ref.variantId ? 'Bewaarde keuze: ' : 'Vanaf maat: ') + variant.title));
      if (data) {
        article.append(element('p', !p.available ? 'Uitverkocht' : ref.variantId && !variant?.available ? 'Deze maat is uitverkocht' : 'Beschikbaar', 'nektar-wishlist-availability'));
        if (safe && this.dataset.quickAdd !== 'false') {
          const add = element('button', 'In winkelwagen', 'button button--primary'); add.type = 'button'; add.dataset.wishlistAdd = '';
          add.addEventListener('click', () => this.add(ref, add, article)); article.append(add);
        } else if (p.available) { const choose = element('a', 'Bekijk artikel en kies je maat', 'button button--secondary'); choose.href = url; article.append(choose); }
      } else {
        article.append(element('p', 'Laden is niet gelukt. Je favoriet blijft bewaard.'));
        const retry = element('button', 'Opnieuw laden', 'button button--secondary'); retry.type = 'button'; retry.addEventListener('click', () => this.render()); article.append(retry);
      }
      const remove = element('button', '♥ Verwijder', 'nektar-wishlist-button nektar-wishlist-remove'); remove.type = 'button';
      Object.assign(remove.dataset, { nektarWishlistToggle: '', handle: ref.productHandle, productId: String(p?.id || ref.productId || ''), title: p?.title || 'artikel', placement: 'wishlist_page' });
      article.append(remove); return article;
    }
    async add(ref, button, article) {
      if (button.disabled) return; button.disabled = true;
      let added = false;
      const feedback = element('p'); feedback.setAttribute('role', 'status'); article.append(feedback);
      try {
        const data = await product(ref.productHandle, true), chosen = data && selection(data, ref);
        if (!chosen?.safe) { feedback.textContent = 'Deze keuze is niet meer beschikbaar. Bekijk het artikel.'; cache.delete(ref.productHandle); return; }
        const controller = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const body = { id: String(chosen.variant.id), quantity: 1 };
        if (controller) { body.sections = controller.getSectionsToRender().map(s => s.id).slice(0, 5); body.sections_url = location.pathname; controller.setActiveElement(button); }
        const response = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
        const result = await response.json(); if (!response.ok || result.status) throw new Error('not-added'); added = true;
        // Saved product stays saved. Existing neutral cart events enable future local conversion joins.
        document.dispatchEvent(new CustomEvent('nektar:cart-add-success', { detail: { productId: String(data.product.id), variantId: String(chosen.variant.id), value: chosen.variant.price / 100, quantity: 1, sourcePlacement: 'wishlist_page' } }));
        const dialog = this.closest('dialog'); if (dialog?.open) dialog.close();
        try { controller?.classList.remove('is-empty'); controller?.renderContents(result); } catch { /* Successful add must not become a retry. */ }
        if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'nektar-wishlist', cartData: result });
        await window.NektarGrowth?.refreshCart(); feedback.textContent = 'Toegevoegd aan je winkelwagen.'; announce(feedback.textContent);
      } catch { feedback.textContent = added ? 'Toegevoegd. Bekijk je winkelwagen.' : 'Toevoegen is niet gelukt. Controleer je winkelwagen en probeer opnieuw.'; }
      finally { button.disabled = false; }
    }
  }
  customElements.define('nektar-wishlist', Wishlist);
  sync();
})();
